import { render, staticRenderFns } from "./sast_issue_body.vue?vue&type=template&id=3b8c3d00&"
import script from "./sast_issue_body.vue?vue&type=script&lang=js&"
export * from "./sast_issue_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports